<template>
  <div>
    <el-table :data="tableData" border style="width: 100%" fit>
      <el-table-column type="index" width="50" label="#"></el-table-column>
      <template v-for="(column, index) in tableConfig.columns">
        <el-table-column
          :prop="column.prop"
          :label="column.lable"
          :min-width="column.minWidth ? column.minWidth : 80"
          :render-header="renderHeader"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="column.type && column.type == 'editSelect'">
              <el-select v-model="scope.row[column.prop]" placeholder :disabled="scope.row['isDisabled']?true:false">
                <el-option
                  v-for="item in column.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>

            <template v-else-if="column.type && column.type == 'editInput'">
              <el-input v-model="scope.row[column.prop]" :disabled="scope.row['isDisabled']?true:false"></el-input>
            </template>

            <template v-else-if="column.type && column.type == 'tag'">
              <el-tag :type="column.options[scope.row[column.prop]].tagType">{{column.options[scope.row[column.prop]].text}}</el-tag>
            </template>

            <template v-else>{{ scope.row[column.prop] }}</template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
    tableData: Array,
  },
  data() {
    return {
      tableConfig: {},
      value: "",
      options: "",
    };
  },
  methods: {
    renderHeader(h, row) {
      var column = row.column;
      //增加溢出隐藏
      return h("span", {}, [
        h("span", ""),
        h("tooltip", {
          props: {
            tips: column.label,
          },
        }),
      ]);
    },
  },
  mounted() {
    this.tableConfig = this.config;
  },
};
</script>